import { render, staticRenderFns } from "./NewFQCAdmin.vue?vue&type=template&id=25813c41&scoped=true"
import script from "./NewFQCAdmin.vue?vue&type=script&lang=js"
export * from "./NewFQCAdmin.vue?vue&type=script&lang=js"
import style0 from "./NewFQCAdmin.vue?vue&type=style&index=0&id=25813c41&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25813c41",
  null
  
)

export default component.exports